const w = window;
const synth = w.speechSynthesis;
const isSupported = 'SpeechSynthesisUtterance' in w && 'speechSynthesis' in w;
export class SpeechSynthesis {
	static speak({
		text = '',
		rate = 1.1,
		pitch = 1.4,
		voice = synth.getVoices()[6],
	} = {}) {
		if (isSupported) {
			const utterance = new w.SpeechSynthesisUtterance();
			utterance.text = text;
			utterance.rate = rate;
			utterance.pitch = pitch;
			utterance.voice = voice;
			text && synth.speak(utterance);
		}
	}
	static cancel() {
		if (isSupported) {
			synth.speaking && synth.cancel();
		}
	}
}

SpeechSynthesis.speak(); // to change the voice because it is not immediately change
